
export default function userRole() {
  return localStorage.getItem("user_role")
}
